import { createContext, useContext } from "react";

const GoogleScriptContext = createContext({ isLoaded: false });

export const GoogleScriptProvider = GoogleScriptContext.Provider;

export const useGoogleScript = () => useContext(GoogleScriptContext);
